import { _ as __rest } from '../tslib.es6-C8rd5pYo.mjs';
import { css, jsx } from '@emotion/react';
import { Colors, Icon } from '@zapier/design-system';
import { Button } from 'react-aria-components';

const ButtonStyles = css({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "var(--zds-radius-small, 3px)",
  padding: `var(--zds-space-4, 10px)`,
  "&[data-hovered]": {
    cursor: "pointer"
  },
  "&[data-disabled]": {
    cursor: "not-allowed"
  },
  "&[data-focus-visible]": {
    outline: `var(--zds-border-focus, 2px solid ${Colors.blue600})`,
    outlineOffset: `var(--zds-space-2, 2px)`
  },
  "&[data-size=small]": {
    width: "var(--zds-size-small, 30px)",
    height: "var(--zds-size-small, 30px)",
    // nested icon size
    span: {
      width: "var(--zds-size-20)",
      height: "var(--zds-size-20)"
    }
  },
  "&[data-size=medium]": {
    width: "var(--zds-size-medium, 44px)",
    height: "var(--zds-size-medium, 44px)",
    // nested icon size
    span: {
      width: "var(--zds-size-24)",
      height: "var(--zds-size-24)"
    }
  },
  "&[data-size=large]": {
    width: "var(--zds-size-large, 50px)",
    height: "var(--zds-size-large, 50px)",
    // nested icon size
    span: {
      width: "var(--zds-size-32)",
      height: "var(--zds-size-32)"
    }
  },
  "&[data-variant='primary']": {
    border: `1px solid var(--zds-ui-primary-stronger, ${Colors.neutral600})`,
    backgroundColor: `var(--zds-ui-primary-stronger, ${Colors.neutral100})`,
    color: `var(--zds-prime-white, ${Colors.neutral800})`,
    "&[data-hovered]": {
      color: `var(--zds-prime-white, ${Colors.blue600})`,
      backgroundColor: `var(--zds-ui-primary-strongest, ${Colors.neutral100})`
    },
    "&[data-disabled]": {
      background: `var(--zds-background-strongest, ${Colors.neutral200})`,
      border: `1px solid var(--zds-background-strongest, ${Colors.neutral400})`,
      color: `var(--zds-text-weakest, ${Colors.neutral500})`
    }
  },
  "&[data-variant='secondary']": {
    color: `var(--zds-ui-primary-stronger, ${Colors.neutral600})`,
    backgroundColor: `var(--zds-ui-primary-weaker, ${Colors.neutral100})`,
    border: `1px solid var(--zds-ui-primary-weaker, ${Colors.neutral600})`,
    "&[data-hovered]": {
      color: `var(--zds-prime-white, ${Colors.neutral800})`,
      backgroundColor: `var(--zds-ui-primary, ${Colors.neutral100})`,
      border: `1px solid var(--zds-ui-primary, ${Colors.neutral600})`
    },
    "&[data-disabled]": {
      color: `var(--zds-text-weakest, ${Colors.earth})`,
      background: `var(--zds-background-strongest, ${Colors.neutral200})`,
      border: `1px solid var(--zds-background-strongest, ${Colors.neutral400})`
    }
  },
  "&[data-variant='tertiary']": css`
    background-color: var(--zds-background-weaker, transparent);
    color: var(--zds-gray-warm-8, ${Colors.blue});
    border-style: solid;
    border-width: 1px;
    border-color: var(--zds-stroke-default, transparent);

    &[data-hovered] {
      background-color: var(--zds-background-stronger, ${Colors.blue10});
    }

    &[data-focus-visible] {
      background-color: var(--zds-background-weaker, ${Colors.blue10});
    }

    &[data-disabled] {
      background-color: var(--zds-background-strongest, transparent);
      border: var(--zds-background-strongest, none);
      color: var(--zds-text-weakest, ${Colors.neutral500});
    }
  `,
  "&[data-variant='ghost']": css`
    color: var(--zds-gray-warm-8, #5140bf);
    background-color: transparent;

    &[data-hovered] {
      background-color: var(--zds-ui-primary-weakest, ${Colors.blue10});
    }

    &[data-focus-visible] {
      background-color: var(--zds-background-weaker, ${Colors.blue10});
    }

    &[data-disabled] {
      background-color: var(--zds-background-strongest, #f5f3eb);
      border-color: var(--zds-background-strongest, #f5f3eb);
      color: var(--zds-text-weakest, #574e4c);
    }
  `,
  "&[data-variant=brand]": css`
    background-color: var(--zds-ui-brand, #ff4f00);
    color: var(--zds-prime-white, #fffdf9);

    &[data-hovered] {
      background-color: var(--zds-ui-brand-stronger, #cc3f00);
    }

    &[data-disabled] {
      background-color: var(--zds-background-strongest, #f5f3eb);
      border-color: var(--zds-background-strongest, #f5f3eb);
      color: var(--zds-text-weakest, #574e4c);
    }
  `
});
const IconButton = (_a) => {
  var { className, isDisabled = false, name, size = "medium", style, variant = "primary" } = _a, props = __rest(_a, ["className", "isDisabled", "name", "size", "style", "variant"]);
  return jsx(
    Button,
    Object.assign({}, props, { className, css: ButtonStyles, "data-variant": variant, "data-size": size, "data-zds": true, isDisabled, style }),
    jsx(Icon, { name, size: 24 })
  );
};

export { IconButton };
//# sourceMappingURL=IconButton.es.js.map
